import { render, staticRenderFns } from "./AlertEvents.vue?vue&type=template&id=16fd185e&scoped=true&"
import script from "./AlertEvents.vue?vue&type=script&lang=js&"
export * from "./AlertEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd185e",
  null
  
)

export default component.exports